export const DocumentToStoreComponents = {
  Default: 'DefaultDocumentToStore',
  Error: 'ErrorNotification'
};